import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import brandData from '../data/brandData'; // Import the brand data

const BrandCarousel = () => {
    const [isMd, setIsMd] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMd(window.innerWidth >= 1000);
      };
  
      handleResize();
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    const renderCarouselView = () => (
      <div className="d-flex flex-column mb-5 gap-3 align-items-center justify-content-center">
        {brandData.map((group, index) => (
          <div
            key={index}
            className="d-flex flex-wrap gap-3 align-items-center justify-content-center"
          >
            {group.map((brand) => (
              <img
                key={brand.alt}
                src={brand.src}
                alt={brand.alt}
                className="flex-shrink-0"
                style={{ width: '200px', height: '200px', objectFit: 'cover', aspectRatio: '1' }}
              />
            ))}
          </div>
        ))}
      </div>
    );
  
    const renderMobileView = () => (
      <div className="brand-carousel-container">
        <div className="brand-carousel-track">
          {brandData.flat().map((brand) => (
            <img
              key={brand.alt}
              src={brand.src}
              alt={brand.alt}
              className="brand-carousel-item"
              style={{ width: '200px', height: '200px', objectFit: 'cover', aspectRatio: '1' }}
            />
          ))}
        </div>
      </div>
    );
  
    return <>{isMd ? renderCarouselView() : renderMobileView()}</>;
  };
  
  export default BrandCarousel;